'use strict';

import { CoreRepository } from '../CoreRepository';
import { UserLetter } from '../../Entities/User/UserLetter';
import { UserLetterCollection } from '../../Collections/User/UserLetterCollection';

export class UserLetterRepository extends CoreRepository {
  public getUserLetters(userId: number, options: object = {}, criteria: object = null) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserLetters(userId, options).then((response) => {
      const collection = new UserLetterCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserLetter();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public getUserLettersGrouped(userId: number, options: object = {}, criteria: object = null) {
    if (!options) options = {};
    if (criteria) options['criteria'] = criteria;

    return this.webAPI.getUserLettersGrouped(userId, options).then((response) => {
      const groupedCollection = {};

      Object.keys(response.data).forEach((folderName) => {
        const collection = new UserLetterCollection();

        response.data[folderName].forEach((itemData) => {
          const item = new UserLetter();
          item.hydrate(itemData);
          collection.addItem(item);
        });

        groupedCollection[folderName] = collection;
      });

      return groupedCollection;
    });
  }

  public getUserLettersSharable(
    userId: number,
    agencyId: number,
    options: object = {},
    criteria: object = null
  ) {
    if (!options) {
      options = {};
    }

    if (criteria) {
      options['criteria'] = criteria;
    }

    return this.webAPI.getUserLettersSharable(userId, agencyId, options).then((response) => {
      const collection = new UserLetterCollection();

      response.data.forEach((collectionItemData) => {
        const collectionItem = new UserLetter();
        collectionItem.hydrate(collectionItemData);

        collection.addItem(collectionItem);
      });

      collection.setOffset(response.offset);
      collection.setLimit(response.limit);
      collection.setTotal(response.total);

      return collection;
    });
  }

  public createUserLetter(userId: number, payload: object = {}) {
    return this.webAPI.createUserLetter(userId, payload).then((response) => {
      return response;
    });
  }

  public updateUserLetter(userId: number, letterId: number, payload: object = {}) {
    return this.webAPI.updateUserLetter(userId, letterId, payload).then((response) => {
      return response;
    });
  }

  public deleteUserLetter(userId: number, letterId: number) {
    return this.webAPI.deleteUserLetter(userId, letterId).then((response) => {
      return response;
    });
  }
}
